import React from 'react';

import { Alert } from '@components/common';

export const NoCandidateAccessAlert: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Alert type='error' className='mb-4'>
    Your account settings prevent you from contacting candidates that belong to a different team.
  </Alert>
);
